import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import Box from "../../../components/_styles/Box";
import { Card, PageTitle } from "../../../styles";
import BackButton from "../../../components/BackButton";
import {
  getPatientsListAction,
  resetPatientsDataAction,
  getFaxesListAction,
} from "../../../actions/radminUploads";
import { InfoIconOutline as InfoIcon } from "../Messages/Icons";
import Flex from "../../../components/_styles/Flex";
import PatientTable from "./PatientTable/PatientTable";
import { EmptyState } from "../../../components/EmptyState/EmptyState";
import LoadMoreButton from "../../../components/LoadMoreButton";
import { ReactComponent as EmptyStateImg } from "../../../assets/empty-state-search.svg";
import Table from "../../../components/Table/Table";
import { TemplateButton } from "../Messages/SmsCreationDialog";
import ShowMessageContent from "../Messages/ShowMessageContent";
import Filter from "../Messages/Filter";
import moment from "moment";

const DoctorName = styled.div`
  margin-left: 10px;
`;

const FaxTitle = styled.div`
    color:#9FA2B4;
  font-size:12px;
  font-weight:600;
  margin-bottom:0;
  padding: 10px 10px 0px 25px;
`;

const SelectContainer = styled.div`
  width: 250px;
`;

const ImportPatientsBtn = styled(Flex)`
  width: 177px;
  background: #ffc342;
  border-radius: 5px;
  font-family: Roboto Condensed;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  &:hover {
    cursor: pointer;
  }
`;

const PageTitleContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

const ToggleContainer = styled(Flex)`
  margin-left: 15px;
  padding: 1px;
  display: flex;
  background: #e6e9f1;
  border-radius: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #0c2945;
  width: max-content;
  height: 41px;
`;

const ToggleButton = styled.button`
  padding: 7px 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? "#0C2945" : "#E6E9F1")};
  color: ${(props) => (props.active ? "#F9FAFC" : "#0C2945")};
  border: 0;
  outline: 0;
  border-radius: 6px;
  font-weight: 600;
`;

const FaxBadge = styled(Flex)`
  width: 112px;
  min-width: 54px;
  padding: 0 5px;
  height: 24px;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  background: ${(props) => {
    switch (props.status) {
      case "success":
        return "#64C67C";

      case "failed":
        return "#9B64C6";

      case "cancelled":
        return "#CF3131";

      case "transmitting":
        return "#FF7A00";

      case "processing":
        return "#ADADAD";

      default:
        return "#DFE0EB";
    }
  }};
`;

const FaxStatusBadge = ({ status }) => (
  <FaxBadge status={status}>{status}</FaxBadge>
);

const columns = [
  { key: "id", name: "Fax ID" },
  { key: "created", name: "Created Date" },
  { key: "cio_campaign_id", name: "Campaign Id" },
  { key: "cio_campaign_name", name: "Campaign Title" },

  {
    key: "status",
    name: "Status",
    displayCell: (cellValue) => <FaxStatusBadge status={cellValue} />,
  },
  { key: "direction", name: "Direction" },
];

const FilterContainer = styled.div`
display: flex;
width: 253px;
align-items: center;
flex-direction: column;
& > div {
  padding: 0px;
  width: 100%;
  & > div {
    width: 100%;
    height: 38px;
    & > span > div > .select__control {
      height: 38px;
    }
    & > span > div {
      height: 38px;
    }
  }
}
`;
const options = [
  { value: "Last 7 days", label: "Last 7 days" },
  { value: "Last 30 days", label: "Last 30 days" },
  { value: "Last 3 months", label: "Last 3 months" },
  { value: "Last 12 months", label: "Last 12 months" },
  { value: "Custom date range", label: "Custom date range" },
];

const SelectDropdownTitle = styled.div`
  margin-bottom: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6D6E6E;
  text-transform: uppercase;
  text-align:left;
`;

const statusOptions = [
  { value: "all", label: "All Faxes" },
  { value: "failed", label: "Failed" },
  { value: "success", label: "Success" },
  { value: "cancelled", label: "Cancelled" },
  { value: "processing", label: "Processing" },
  { value: "transmitting", label: "Transmitting" },
];

const directionOptions = [
  { value: 'inbound and outbound', label: 'Incoming & Outgoing' },
  { value: 'inbound', label: 'Incoming' },
  { value: 'outbound', label: 'Outgoing' },
];


const Option = (props) => {
  return (
    <>
      <components.Option {...props}>
        <span style={{ marginRight: 5, paddingTop: 5 }}>
          <input
            type="radio"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginTop: 5 }}
          />{" "}
        </span>
        <label>{props.label}</label>
      </components.Option>
    </>
  );
};

 const MultiOption = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: "10px",
            }}
          >
            <input
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
              style={{ margin: "0 5px", verticalAlign: "middle" }}
            />{" "}
            <label style={{ margin: "0" }}>{props.label}</label>
          </div>
        </components.Option>
      </div>
    );
  };

const PatientList = ({ history }) => {
  const patients = useSelector((state) => state.radAdmin.patients);
  const faxes = useSelector((state) => state.radAdmin.referringPhysicianFaxes);

  const { doctorId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const itemsPortionSize = 10;
  
    let params = new URLSearchParams(history.location.search);
    let view = params.get("tab");
    let initialDirectionValueFax = params.get("fax-direction");

  
    let timeframe =
      view === "fax" ? params.get("timeframe") || "Last 30 days" : "Last 30 days";
    let status = params.get("fax-status");
    let direction = params.get('fax-direction');
  
    let timeframeItem = options.find((itm) => itm.value === timeframe);
    if (timeframe && !timeframeItem) {
    timeframeItem = {
      value: "Custom date range",
      label: "Custom date range",
    };
  }
    const statusItem = statusOptions.find((itm) => itm.value === status);
    const directionItem=  directionOptions.find(itm => itm.value === direction)
    var date = new Date();
     let requiredDate;
      let lastMoment;
      let startingDate;
      let endingDate;
      if (timeframe) {
        if (
          timeframe !== "Last 7 days" &&
          timeframe !== "Last 30 days" &&
          timeframe !== "Last 3 months" &&
          timeframe !== "Last 12 months"
        ) {
          const timeframeData = timeframe.split("-");
          const formattedDateStringStart = timeframeData[0];
          const formattedDateStringEnd = timeframeData[1];
          const dateObjStart = moment(formattedDateStringStart, "MM/DD/YYYY");
          const dateObjEnd = moment(formattedDateStringEnd, "MM/DD/YYYY");
    
          const day = dateObjStart.format("DD");
          const month = dateObjStart.format("MMM");
          const year = dateObjStart.format("YYYY");
    
          startingDate = `${dateObjStart.format(
            "ddd"
          )} ${month} ${day} ${year} 00:00:00 GMT+0530 (India Standard Time)`;
    
          const day2 = dateObjEnd.format("DD");
          const month2 = dateObjEnd.format("MMM");
          const year2 = dateObjEnd.format("YYYY");
    
    
          endingDate = `${dateObjEnd.format(
            "ddd"
          )} ${month2} ${day2} ${year2} 00:00:00 GMT+0530 (India Standard Time)`;
        } else {
          if (timeframe === "Last 7 days") {
            lastMoment = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
          } else if (timeframe === "Last 30 days") {
            lastMoment = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000);
          } else if (timeframe === "Last 3 months") {
            lastMoment = new Date(date.getTime() - 90 * 24 * 60 * 60 * 1000);
          }
    
          if (timeframe === "Last 12 months") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear() - 1;
            requiredDate = `${month}/${day}/${year}`;
          } else {
            let day = lastMoment?.getDate();
            let month = lastMoment?.getMonth() + 1;
            let year = lastMoment?.getFullYear();
            requiredDate = `${month}/${day}/${year}`;
          }
        }
      }

    const [filterValue, setFilterValue] = useState(timeframeItem || null);
    const [statusValue, setStatusValue] = useState(statusItem || null);
    const [directionValue, setDirectionValue] = useState(directionItem || null);
      const [selectedDirection, setSelectedDirection] = useState(direction || "");
  const [displayItemsCount, setDisplayItemsCount] = useState(itemsPortionSize);
  const [pageNumber, setPageNumber] = useState(1);
  const [faxContent, setFaxContent] = useState("");
  const [selectedFax, setSelectedFax] = useState();
   const [selectedDate, setSelectedDate] = useState(
      requiredDate || ""
    );
     const [selectedFaxDirection, setSelectedFaxDirection] = useState(
        initialDirectionValueFax || ""
      );
    const [startDate, setStartDate] = useState(startingDate || "");
    const [endDate, setEndDate] = useState(endingDate || "");
  
  const [showMessageContent, setShowMessageContent] = useState(false);
  const queryParams = new URLSearchParams(location.search);

  const activeTab = queryParams.get("tab") || "patients";

  const totalItems =
    activeTab === "patients" ? patients?.totalItems : faxes?.physicianName && faxes?.totalItems;

   const patientName= activeTab === "patients"
                    ? patients?.data?.physician?.name
                    : `${faxes?.physicianName?.first_name ?? ""} ${
                        faxes?.physicianName?.last_name ?? ""
                      }`
  
   useEffect(() => {
    if(activeTab === 'fax') {
      if (filterValue) {
        var date = new Date();
        let requiredDate;
        let lastMoment;
        let params = new URLSearchParams(history.location.search);
        let direction = params.get("fax-direction");
        let status = params.get("fax-status");
        let boundFilter = status ? `&fax-status=${status}` : "";
        let directionBoundFilter = direction ? `&fax-direction=${direction}` : "";
         let tab = params.get("tab");
        let tabType = tab ? `tab=${tab}&` : "";
  
        setPageNumber(1);
        if (filterValue.value === "Custom date range") return;
        setStartDate("");
        setEndDate("");
        history.push({
          pathname: `/auth/radAdmin/referringDocs/${doctorId}`,
          search: `?${tabType}timeframe=${filterValue.value}${boundFilter}${directionBoundFilter}`,
        });
        if (filterValue.value === "Last 7 days") {
          lastMoment = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
        } else if (filterValue.value === "Last 30 days") {
          lastMoment = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000);
        } else if (filterValue.value === "Last 3 months") {
          lastMoment = new Date(date.getTime() - 90 * 24 * 60 * 60 * 1000);
        }
        if (filterValue.value === "Last 12 months") {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear() - 1;
          requiredDate = `${month}/${day}/${year}`;
          setSelectedDate(requiredDate);
          return;
        }
        let day = lastMoment.getDate();
        let month = lastMoment.getMonth() + 1;
        let year = lastMoment.getFullYear();
        requiredDate = `${month}/${day}/${year}`;
        setSelectedDate(requiredDate);
      }
    }
    }, [filterValue, history, activeTab]);
  
    
    useEffect(() => {
      if(activeTab === 'fax') {
          if (directionValue) {
            setSelectedFaxDirection(directionValue.value);
            setPageNumber(1);
            let params = new URLSearchParams(history.location.search);
            let timeframe = params.get("timeframe");
            let durationFilter = timeframe ? `timeframe=${timeframe}&` : "";
            let status = params.get("fax-status");
            let tab = params.get("tab");
        let tabType = tab ? `tab=${tab}&` : "";
            let statusFilter = status ? `fax-status=${status}&` : "";
            history.push({
              pathname: `/auth/radAdmin/referringDocs/${doctorId}`,
          search: `?${tabType}${durationFilter}${statusFilter}fax-direction=${directionValue.value}`,
            });
          }
        }
        }, [directionValue, history, activeTab]);
  
    useEffect(() => {
 if(activeTab === 'fax') {
      if (statusValue) {
  
        setSelectedDirection(statusValue.value);
        setPageNumber(1);
        let params = new URLSearchParams(history.location.search);
        let timeframe = params.get("timeframe");
         let tab = params.get("tab");
        let tabType = tab ? `tab=${tab}&` : "";
        let durationFilter = timeframe ? `timeframe=${timeframe}&` : "";
        let direction = params.get("fax-direction");
        let directionFilter = direction ? `fax-direction=${direction}&` : "";
  
        history.push({
          pathname: `/auth/radAdmin/referringDocs/${doctorId}`,
          search: `?${tabType}${durationFilter}${directionFilter}fax-status=${statusValue.value}`,
        });
      }
    }
    }, [statusValue, history, activeTab]);
  
   useEffect(() => {
    if(activeTab === 'fax') {
     if (startDate && endDate) {
        let params = new URLSearchParams(history.location.search);
        let tab = params.get("tab");
        let tabType = tab ? `tab=${tab}&` : "";
        let status = params.get("fax-status");
        let boundFilter = status ? `&fax-status=${status}` : "";
        let startingDate, endingDate;
        if (startDate) {
          startingDate = moment(startDate).format("MM/DD/YYYY");
        }
        if (endDate) {
          endingDate = moment(endDate).format("MM/DD/YYYY");
        }
        history.push({
          pathname: `/auth/radAdmin/referringDocs/${doctorId}`,
          search: `?${tabType}timeframe=${startingDate}-${endingDate}${boundFilter}`,
        });
      }
    }
     
    }, [startDate, endDate, history, activeTab]);

  useEffect(() => {
    if (pageNumber) {
      if (activeTab === "patients") {
        dispatch(getPatientsListAction(pageNumber, doctorId));
      } else if (activeTab === "fax" && (selectedDate || endDate)) {
        dispatch(getFaxesListAction(pageNumber, doctorId, selectedDate || "", startDate && endDate ? {startDate, endingDate}: {}, selectedFaxDirection || "", statusValue ));
      }
    }
  }, [pageNumber, doctorId, activeTab, dispatch, startDate, endDate, statusValue, selectedFaxDirection, selectedDate]);

  useEffect(() => {
    if (!queryParams.get("tab")) {
      queryParams.set("tab", "patients");
      history.replace(
        `/auth/radAdmin/referringDocs/${doctorId}?${queryParams.toString()}`
      );
    }
  }, [doctorId, history]);

  const moveToDoctors = () => {
    history.push("/auth/radAdmin/referringDocs");
    window.analytics.track("Patient-List-Referrer-Back-Click");
  };

  const moveToImportPatients = () => {
    history.push("/auth/radAdmin/Import");
    window.analytics.track("Patient-List-Import-Patients-Click");
  };

  const recoConfigData = useSelector((state) => state.radAdmin.recoConfig.data);

  const onLoadMore = () => {
    setDisplayItemsCount((prevCount) => prevCount + itemsPortionSize);
    setPageNumber((prevNumber) => prevNumber + 1);
  };

  const dialogHandler = () => {
    setShowMessageContent(!showMessageContent);
  };

  const updateUrl = (paramsToUpdate) => {
    const params = new URLSearchParams(location.search);

    Object.keys(paramsToUpdate).forEach((key) => {
      if (paramsToUpdate[key] !== undefined && paramsToUpdate[key] !== "") {
        params.set(key, paramsToUpdate[key]);
      } else {
        params.delete(key);
      }
    });

    history.replace({ search: params.toString() });
  };

  const handleTabChange = (tab) => {
    updateUrl({tab: tab, timeframe: '', 'fax-status': '', 'fax-direction': ''});
    if(tab === 'fax') {
     setStatusValue(null);
     setFilterValue(timeframeItem);
     setDirectionValue(null);
    }
    setPageNumber(1);
    setDisplayItemsCount(itemsPortionSize);
  };

  const ClickHandlerFaxContent = (value) => {
    window.analytics.track("Message-Deliveries-Fax-View-Content-Click");
    setFaxContent(value?.attachment);
    setSelectedFax(value);
    setShowMessageContent(!showMessageContent);
  };

  return (
    <Box p={30}>
      <PageTitle>
        <PageTitleContainer>
          <Flex align="center">
            <BackButton
            onClick={moveToDoctors}
              fallbackPath={"/auth/radAdmin/referringDocs"}
              style={{ marginBottom: 0 }}
            />
            <DoctorName>
              {`${patientName ? `${patientName}` : ''}${totalItems ? `: ${totalItems}`: ': 0'}`}
            </DoctorName>

            <ToggleContainer>
              <ToggleButton
                active={activeTab === "patients"}
                onClick={() => handleTabChange("patients")}
                >
                Patients
              </ToggleButton>
              <ToggleButton
                active={activeTab === "fax"}
                onClick={() => handleTabChange("fax")}
                >
                Fax
              </ToggleButton>
            </ToggleContainer>
          </Flex>

          {activeTab === "patients" && (
            <ImportPatientsBtn onClick={moveToImportPatients}>
              Import Patients
            </ImportPatientsBtn>
          )}
        </PageTitleContainer>
      </PageTitle>
      <FaxTitle>Fax Number : {faxes?.physicianName?.fax}</FaxTitle>

      {activeTab === "fax" ? (
        <div>
          <div style={{ display: "flex", gap: "16px", marginLeft: "36px", marginTop: '30px' }}>
            <div>
              <FilterContainer>
                <SelectDropdownTitle>timeframe</SelectDropdownTitle>
                <Filter
                  options={options}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  setSelectedDate={setSelectedDate}
                  type="radio"
                  selectContainerStyles={{ textAlign: "left" }}
                  popperPlacement={'bottom-start'}
                />
              </FilterContainer>
            </div>
            <div>
              <SelectContainer key={"item"}>
                <SelectDropdownTitle>status</SelectDropdownTitle>
                <Select
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={statusOptions}
                  value={statusValue}
                  onChange={(value) => setStatusValue(value)}
                  styles={{
                    option: (styles, { isSelected }) => ({
                      ...styles,
                      fontSize: "15px",
                      textAlign: "left",
                      height: "40px",
                      fontWeight: isSelected ? 600 : 100,
                      alignItems: "center",
                    }),
                    control: (styles) => ({
                      ...styles,
                      textAlign: "left",
                    }),
                  }}
                  isSearchable={false}
                  components={{
                    Option,
                  }}
                />
              </SelectContainer>
            </div>
            <div>
              <SelectContainer key={"item"}>
                <SelectDropdownTitle>Direction</SelectDropdownTitle>
                <Select
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={directionOptions}
                  value={directionValue}
                  onChange={(value) => setDirectionValue(value)}
                  styles={{
                    option: (styles, { isSelected }) => ({
                      ...styles,
                      fontSize: "15px",
                      textAlign: "left",
                      height: "40px",
                      fontWeight: isSelected ? 600 : 100,
                      alignItems: "center",
                    }),
                    control: (styles) => ({
                      ...styles,
                      textAlign: "left",
                    }),
                  }}
                  isSearchable={false}
                  components={{
                    Option,
                  }}
                />
              </SelectContainer>
            </div>
          </div>
        </div>
      ) : null}

      <Card>
        {activeTab === "patients" ? (
          <>
            <PatientTable
              patientsData={
                activeTab === "patients"
                  ? patients.data?.patients?.slice(0, displayItemsCount)
                  : faxes.data?.faxes?.slice(0, displayItemsCount)
              }
              isLoading={
                pageNumber === 1 &&
                (activeTab === "patients"
                  ? patients.isLoading
                  : faxes.isLoading)
              }
              physicianData={patients?.data?.physician}
              resetDataAction={resetPatientsDataAction}
              noDataRender={() => (
                <EmptyState title={"No Results"} img={() => <EmptyStateImg />}>
                  Sorry, there are no results
                </EmptyState>
              )}
            />
            {((activeTab === "patients" && patients?.data?.patients?.length) ||
              (activeTab === "fax" && faxes?.data?.faxes?.length)) > 0 && (
              <LoadMoreButton
                title="Load more"
                handleClick={onLoadMore}
                isDisabled={totalItems < displayItemsCount}
                isLoading={
                  activeTab === "patients"
                    ? patients?.isLoading
                    : faxes?.isLoading
                }
              />
            )}
          </>
        ) : (
          <>
            <Table
              rows={faxes.data && faxes.data}
              columns={[
                ...columns,
                {
                  key: "fax",
                  name: "Recipient Fax Number",
                  displayCell: (col, cellValue, row) => {
                    return (
                      <div style={{  gap: "6px" }}>
                        <span>{col}</span>
                      </div>
                    );
                  }
                },
                {
                  key: "upload_file",
                  name: "",
                  displayCell: (col, cellValue, id) => (
                    <TemplateButton
                      width="100"
                      color="#00AEEF"
                      border={true}
                      outlinedBr={"#00AEEF"}
                      title="View Content"
                      icon={<InfoIcon />}
                      clickHandler={() => ClickHandlerFaxContent(cellValue)}
                      style={{
                        height: "38px",
                        borderRadius: "8px",
                        borderWidth: "2px",
                        padding: "9.5px 12.5px",
                        width: "144px",
                        gap: "10px",
                      }}
                      iconContainerStyles={{ padding: "0px" }}
                      textStyles={{
                        fontFamily: "Open Sans",
                        lineHeight: "19px",
                        whiteSpace: "nowrap",
                      }}
                    ></TemplateButton>
                  ),
                },
              ]}
              initialPageNumber={pageNumber}
              totalItems={totalItems}
              isLoadingRows={faxes?.isLoading && pageNumber === 1}
              clickHandler={() => null}
              getRowsAction={(pageNumber) => {}}
              shouldGetRowActions={false}
              noDataRender={() => (
                <EmptyState
                  title={"No Results"}
                  img={() => <EmptyStateImg />}
                  buttonInfo={{
                    link: "/auth/radAdmin/Import",
                    text: "Import Data",
                  }}
                >
                  Sorry, there are no results
                </EmptyState>
              )}
            />
            {faxes && faxes?.data?.length !== 0 && (
              <LoadMoreButton
                title="Load more"
                isLoading={faxes.isLoading && pageNumber !== 1}
                handleClick={onLoadMore}
                isDisabled={totalItems === faxes?.data?.length}
                style={{ backgroundColor: "#0C2945", fontWeight: 600 }}
              />
            )}
          </>
        )}
      </Card>
      <ShowMessageContent
        messageContent={faxContent}
        show={showMessageContent}
        dialogHandler={dialogHandler}
        customHeader="Fax Content"
        isEmailType={false}
        recipientFax={selectedFax?.direction ==="outbound"? selectedFax?.fax : recoConfigData?.name}
        sourceEmail={selectedFax?.direction ==="inbound"? (selectedFax?.fax ?? "-") : recoConfigData?.name}
        sourceFax={recoConfigData?.name || "-"}
        isPdf={true}
        styles={{ width: "50rem" }}
      />
    </Box>
  );
};

export default PatientList;
